export default __webpack_public_path__ + "static/media/6.5b417e1f.jpg";